var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RepairFacilitiesListItemCtrl = function () {
    function RepairFacilitiesListItemCtrl($element) {
        _classCallCheck(this, RepairFacilitiesListItemCtrl);

        this.element = $element;
    }

    _createClass(RepairFacilitiesListItemCtrl, [{
        key: "$onChanges",
        value: function $onChanges(_ref) {
            var selected = _ref.selected;

            if (selected && selected.currentValue && selected.currentValue !== selected.previousValue && selected.currentValue === true) {
                var targetTop = this.element.position().top;
                this.onScrollIntoView({ top: targetTop });
            }
        }
    }]);

    return RepairFacilitiesListItemCtrl;
}();

export default RepairFacilitiesListItemCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/pa/components/RepairFacilitiesListItem/RepairFacilitiesListItemCtrl.js
// module id = 1559
// module chunks = 0